/**
 * @file     RayAvatar.tsx
 * @purpose  Ray's cut-out portrait in a circle on the chip tint, from the square
 *           crops in public/prompts (128 for up to 64 CSS px at 2x, 192 above).
 */

import Box from '@mui/material/Box';
import { brandConfig } from '@/core/config/brand';
import { promptColors, promptRadius } from './promptStyles';

export function RayAvatar({ size, decorative = true }: { size: number; decorative?: boolean }) {
  return (
    <Box
      component="span"
      sx={{
        flexShrink: 0,
        display: 'inline-flex',
        width: size,
        height: size,
        borderRadius: `${promptRadius.pill}px`,
        overflow: 'hidden',
        backgroundColor: promptColors.chip,
      }}
    >
      <Box
        component="img"
        src="/prompts/ray-avatar-128.png"
        srcSet="/prompts/ray-avatar-128.png 128w, /prompts/ray-avatar-192.png 192w"
        sizes={`${size}px`}
        width={size}
        height={size}
        alt={decorative ? '' : brandConfig.agentName}
        loading="lazy"
        decoding="async"
        sx={{ display: 'block', width: size, height: size }}
      />
    </Box>
  );
}

export function CloseIcon({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  );
}
